export default __webpack_public_path__ + "static/updateVideo-f16220573e51613c422927b1b10d3367.webm";